var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-container"},[_c('img',{attrs:{"src":require("../../common/img/no-course.png"),"alt":"","srcset":""}}),_vm._v(" "),_c('p',{staticClass:"no-data-tips"},[_vm._v(_vm._s(_vm.tips || '暂无数据'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a359a5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Public/NoData.vue
// module id = null
// module chunks = 